import React, { useState } from 'react'
import styles from './TeacherSignup.module.scss'
import routes from '../../../routes'
import Button from '../../Button';
import Typography from "../../Typography";
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import useQueryString from '../../../hooks/use-query-string';

const TeacherLoginCode = () => {
  const [code, setCode] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [newCodeRequested, setNewCodeRequested] = useState(false);
  const { email, school_id } = useQueryString();

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitting(true);

    const axiosInstanceRemote = axios.create({
      baseURL: '/',
    })

    axiosInstanceRemote
      .post('users/login_with_code', { school_id: school_id, email: email, code: code })
      .then((response) => {
        if (response.data.status === 200) {
          window.location = `/schools/${school_id}/class_pictures`
        } else {
          setSubmitting(false);
          toast(response.data.error,
            { type: 'error' })
        }

      })
      .catch((e) => {
        console.log(e)
        setSubmitting(false);
        toast("There was an error with your verification code. Please try again.",
          { type: 'error' })
      })
  }

  const requestCode = (e) => {
    e.preventDefault()

    setSubmitting(true);

    const axiosInstanceRemote = axios.create({
      baseURL: '/',
    })

    axiosInstanceRemote
      .post('users/generate_otp', { school_id: school_id, email: email })
      .then(() => {
        setNewCodeRequested(true);
        setSubmitting(false);
      })
      .catch(() => {
        setSubmitting(false);
        toast("There was an error requesting a new code. Please try again later.",
          { type: 'error' })
      })
  }

  return (
    <div className={styles.page}>
      <ToastContainer position="bottom-left" />

      <form className={`${styles.form}`} onSubmit={handleSubmit}>
        <Typography align="center" tag="h1" weight="bold">
          Please enter the 5-digit verification code that was emailed to you.
        </Typography>

        <Typography align="center" tag="p">
          {newCodeRequested ? (
            <>
              A new code has been emailed to you.
            </>
          ) : (
            <>
              Didn't receive a code? Click <a className={styles.link} onClick={requestCode}>here</a> to receive another.
            </>
          )}
        </Typography>

        <hr />

        <div className={styles.codeForm}>
          <div className={styles.inputContainer}>
            <label>
              Verification Code
              <input
                type="number"
                required
                value={code}
                onChange={(e) => setCode(e.target.value)} />
            </label>
          </div>
        </div>

        <div className={styles.codeForm}>
          <div className={styles.inputContainer}>
            <Button fullWidth type="submit" variant="primary" disabled={submitting || !code}>
              Continue
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default TeacherLoginCode;
